import axios from 'axios'

const http = axios.create({ timeout: 30000 })

function unwrap(resp) {
  const body = resp && resp.data
  if (body && body.code == 0) {
    return body.data
  }
  const err = new Error((body && (body.msg || body.message)) || '请求失败')
  err.code = body && body.code
  throw err
}

function getJson(url) {
  return fetch(url).then((r) => r.json()).then((body) => {
    if (!body || body.code != 0) {
      throw new Error((body && (body.msg || body.message)) || '请求失败')
    }
    return body.data
  })
}

export const portalApi = {
  brand() {
    return getJson('/api/portal/brand')
  },
  policy() {
    return getJson('/api/portal/policy')
  },
  issueCaptcha() {
    return http.post('/api/portal/captcha/issue').then(unwrap)
  },
  verifyCaptcha(payload) {
    return http.post('/api/portal/captcha/verify', payload).then(unwrap)
  },
  uploadAttachment(captchaToken, file) {
    const form = new FormData()
    form.append('captchaToken', captchaToken)
    form.append('file', file)
    return http.post('/api/portal/attachments', form, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(unwrap)
  },
  submit(payload) {
    return http.post('/api/portal/submissions', payload).then(unwrap)
  },
  advisories(params) {
    const q = new URLSearchParams()
    Object.keys(params || {}).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        q.set(key, params[key])
      }
    })
    return getJson('/api/portal/advisories?' + q.toString()).then((payload) => {
      if (Array.isArray(payload)) {
        return payload
      }
      return (payload && (payload.Data || payload.data)) || []
    })
  },
  advisory(id) {
    return getJson('/api/portal/advisories/' + encodeURIComponent(id))
  }
}
